export const hasScrolledPastHero = (dimensions, windowScrollY) => {
    const heroRatio = dimensions.height * 0.65;

    let heroHeight;
    if (heroRatio >= 300 && heroRatio <= 600) {
        heroHeight = heroRatio;
    } else if (heroRatio < 300) {
        heroHeight = 300;
    } else if (heroRatio > 600) {
        heroHeight = 600;
    }

    if (windowScrollY >= heroHeight) {
        return true;
    }

    return false;
};
